import { render, staticRenderFns } from "./ProcesoMain.vue?vue&type=template&id=4dbf99aa&"
import script from "./ProcesoMain.vue?vue&type=script&lang=js&"
export * from "./ProcesoMain.vue?vue&type=script&lang=js&"
import style0 from "./ProcesoMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports